import type { FaireProductEntity } from "../../entity_types/product";

export const p_63ee10x8ey: FaireProductEntity = {
  token: "p_63ee10x8ey",
  type: "product",
  name: "Women's Coffee Cups Novelty Socks",
  brandName: "Selini New York",
  imageUrl:
    "https://cdn.faire.com/fastly/f6d85275e4160c95e153643ed24bb58ee708ca0c5f951c226996e2c3da52095c.jpeg",
  priceDollars: 1,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/2bb269f2841eb91c1daf6119c3423925b096d296aeaa1906e00da7c545ca9f03.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
